const auth = {
  logout: "Déconnexion",
};
export default auth;
